import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Spinner } from 'reactstrap';
import Swal from 'sweetalert2';
import { startFreeTrial, startTrialReset } from 'redux/Trial/TrialActions';
import { getUserData } from 'redux/UserAuthentication/LoginActions';
import { getSpecialtyFields } from 'config/subscriptionPlans';
import { getSpecialty } from 'config/specialtyConfig';

const StartTrialButton = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [canStartTrial, setCanStartTrial] = useState(false);

    useEffect(() => {
        const userDetails = props.userDetails;

        // Can start trial if:
        // 1. Not a UAS student
        // 2. No existing trial
        // 3. No active subscription
        const fields = getSpecialtyFields(props.activeSpecialty);
        const isUAS = userDetails[fields.ultimateAdvisingStudent] === true || userDetails[fields.ultimateAdvisingStudent] === "true";
        const hasTrial = !!userDetails[fields.trialStartDate];

        let hasSubscription = false;
        if (props.fetchDetailsSubscription?.fetchdetailssubscription?.length) {
            const subsDetails = props.fetchDetailsSubscription.fetchdetailssubscription[0];
            hasSubscription = subsDetails.status === "active" || subsDetails.status === "trialing";
        }

        setCanStartTrial(!isUAS && !hasTrial && !hasSubscription);
    }, [props.userDetails, props.fetchDetailsSubscription, props.activeSpecialty]);

    useEffect(() => {
        if (props.trial.success) {
            Swal.fire({
                title: 'Trial Started!',
                text: `Your 14-day free trial has begun. Enjoy full access to ${getSpecialty(props.activeSpecialty).name} Prep!`,
                icon: 'success',
                timer: 3000
            }).then(() => {
                dispatch(startTrialReset());
                // Refresh user data to get updated trialStartDate
                dispatch(getUserData({ onLogin: true }));
                // Redirect to create test page so the user sees their trial is active
                history.push('/client/question-bank/create-test');
            });
        }

        if (props.trial.error) {
            Swal.fire({
                title: 'Error',
                text: props.trial.error,
                icon: 'error',
            }).then(() => {
                dispatch(startTrialReset());
            });
        }
    }, [props.trial]);

    const handleStartTrial = () => {
        dispatch(startFreeTrial());
    };

    if (!canStartTrial) return null;

    return (
        <Button
            color="success"
            size="lg"
            onClick={handleStartTrial}
            disabled={props.trial.loading}
            className={props.className || ''}
        >
            {props.trial.loading ? (
                <>
                    <Spinner size="sm" className="mr-2" />
                    Starting Trial...
                </>
            ) : (
                <>
                    <i className="fas fa-gift mr-2"></i>
                    Start 14-Day Free Trial
                </>
            )}
        </Button>
    );
};

const mapStateToProps = state => {
    return {
        userDetails: state.loginAuth.userDetails,
        fetchDetailsSubscription: state.fetchDetailsSubscription,
        trial: state.trial,
        activeSpecialty: state.specialty.activeSpecialty,
    };
};

export default connect(mapStateToProps)(StartTrialButton);
